import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {SIZE_PAGINATION} from "../../conf";
import {useMutation, UseMutationResult, useQuery, UseQueryResult} from "@tanstack/react-query";
import {ObservationInterface} from "../interface/catalogs/observation-interface";
import {PaginationObservationInterface} from "../interface/catalogs/pagination-observation-interface";

export const findAudQuery = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/audit/current_user/basic_info`,
        {
            page: data.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/audit/current_user/basic_info', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /audit/current_user/basic_info`);
    })
}

export const useFindAudQuery = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findAudQuery(data),
    });
}

export const findObservations = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        data.service ? data.service : `/observation/list`,
        {
            identifier: data.identifier,
            page: data.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: PaginationObservationInterface = interceptorResponse(response.data.object)
            return resp ? resp : {content: [], page: 0, totalPages: 0, totalElements: 0};
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/observation/list', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /observation/list`);
    })
}

export const useFindObservations = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findObservations(data),
    });
}

export const getListCatalogRisk = async () => {
    return await configAxios.get(`/catalog/risk_levels`)
        .then(response => {
            if (response.data.status !== 1) {
                throw new Error(response.data.message);
            } else {
                return interceptorResponse(response.data.object)
            }
        }).catch(error => {
            errorHandlerServices(error, true, '/catalog/risk_levels', undefined)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /catalog/risk_levels`);
        })
}

export const useListAllUsersStatus = (): UseQueryResult<any, Error> => {
    return useQuery({queryKey: ['getListCatalogRisk'], queryFn: () => getListCatalogRisk()});
}

export const createObservation = async (data: ObservationInterface) => {
    return await configAxios.post(
        `/observation/create`, data
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp = interceptorResponse(response.data.object);
            return resp ? resp : data
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/observation/create', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /observation/create`);
    })
}

export const useCreateObservation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: ObservationInterface) => createObservation(data),
    });
}

export const deleteObservation = async (data: ObservationInterface) => {
    return await configAxios.post(
        `/observation/delete`, data
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp = interceptorResponse(response.data.object);
            return resp ? resp : data
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/observation/delete', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /observation/delete`);
    })
}

export const useDeleteObservation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: ObservationInterface) => deleteObservation(data),
    });
}
